import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import user from './modules/user'
import permission from './modules/permission'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    user,
    permission
  },
  state: {
    /**
     * 凤阳街泰沙社区 5848663BE47243ABBC1B7FA5DB78AD7C
     * 海幢街社区 DFCA955261D34F2A9B7D43473660AC66
     *
     */
    companyIds: ['5848663BE47243ABBC1B7FA5DB78AD7C','DFCA955261D34F2A9B7D43473660AC66']
  },
  getters,
})


export default store



// WEBPACK FOOTER //
// ./src/store/index.js